import Entity from "../../core/entity/Entity";
import { objectEntries } from "../../core/util/ObjectUtils";
import { RunEntity } from "../LevelEntity";
import { upgradeDefinitions, UpgradeId } from "./UpgradeDefinitions";

export default class UpgradeManager extends RunEntity implements Entity {
  id = "upgradeManager";

  private _chosenUpgrades: UpgradeId[] = [];

  get chosenUpgrades(): readonly UpgradeId[] {
    return this._chosenUpgrades;
  }

  onUpgradeChosen(eventData: { upgrade: string }) {
    const upgradeId = eventData.upgrade as UpgradeId;

    if (!this._chosenUpgrades.includes(upgradeId)) {
      this._chosenUpgrades.push(upgradeId);
      console.log(
        `Upgrade added: ${upgradeId}. Total upgrades: ${this._chosenUpgrades.length}`,
      );
    } else {
      console.log(`Upgrade ${upgradeId} already chosen, skipping duplicate`);
    }
  }

  /**
   * Check if an upgrade has been purchased
   */
  has(upgradeId: UpgradeId): boolean {
    return this._chosenUpgrades.includes(upgradeId);
  }

  reset() {
    this._chosenUpgrades = [];
  }

  /**
   * Get upgrades available for purchase based on tech tree dependencies
   */
  getAvailableUpgrades() {
    return objectEntries(upgradeDefinitions).filter(([id, upgrade]) => {
      // Skip if already owned
      if (this.has(id)) return false;

      // Check if all dependencies are met
      if ("dependencies" in upgrade && upgrade.dependencies) {
        return upgrade.dependencies.every((dep) => this.has(dep));
      }

      // No dependencies, so it's available
      return true;
    });
  }
}
